import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderComponent from "./HeaderComponent";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchQuejaById } from "../../services/apiService";
import FooterComponent from "./FooterComponent";
import { Container } from "react-bootstrap";

const DetailPostQueja = () => {
  
  const { id } = useParams();
  const [queja, setQueja] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  document.title = "Seguimiento Queja";

  useEffect(() => {
    const loadQueja = async () => {
      try {
        const data = await fetchQuejaById(id);
        setQueja(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadQueja();
  }, [id]);

  if (loading) return <div className="text-center mt-4">Cargando...</div>;
  if (error)
    return <div className="alert alert-danger mt-4">Error: {error}</div>;
  if (!queja)
    return (
      <div className="alert alert-warning mt-4">No se encontró la denuncia</div>
    );

  // Descargar Evidencia

  return (
    <div
      style={{
        //backgroundImage:"url(https://www.veracruz.gob.mx/proteccioncivil/wp-content/uploads/sites/5/2024/12/459029599_938750401627993_9216811163148847696_n.jpg)",
        backgroundImage: "url(/background2.jpeg)",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat"
      }}
    >
      <HeaderComponent />
      <br/>
      <Container style={{ flex: 1 }}>
      <div
        className="container"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.90)",
          borderRadius: "10px",
          padding: "20px",
          marginBottom: "20px",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
          //maxHeight: "calc(100vh - 200px)", // Ajusta según necesidades
          //overflowY: "auto", // Habilita scroll solo para el formulario
        }}
      >
        <h3 className="text-center text-contrast" style={{ color: "black" }}>
          {" "}
          
          DETALLE QUEJAS Y DENUNCIAS CIUDADANA
        </h3>

        <br />

        <div>
          <div className="row">
            {/* Columna Izquierda */}
            <div className="col-md-6">
              <p>
                <strong>Folio:</strong> {queja.folio}
              </p>
              <p>
                <strong>Fecha:</strong> {queja.fecha?.split("T")[0]}
              </p>
              <p>
                <strong>Razón Social:</strong> {queja.einstitucion}
              </p>
              <p>
                <strong>Giro Comercial:</strong> {queja.eginstitucion}
              </p>
              <p>
                <strong>Dirección:</strong> {queja.ecalle} {queja.enumero}
              </p>
              <p>
                <strong>Entre calles:</strong> {queja.ecalles}
              </p>
            </div>

            {/* Columna Derecha */}
            <div className="col-md-6">
              <p>
                <strong>Municipio:</strong>{" "}
                {queja.localidad?.municipio?.municipio}
              </p>
              <p>
                <strong>Localidad:</strong> {queja.localidad?.localidad}
              </p>
              <p>
                <strong>Actividad:</strong> {queja.subActividad?.actividad}
              </p>
              <p>
                <strong>Tipo de Riesgo:</strong> {queja.subActividad?.riesgo}
              </p>
            </div>
            <p className="rojo">Importante :</p>
            <p>
              {" "}
              No olvides guardar número de Folio, llegará por correo electrónico el resumen de la queja/denuncia
              <br/>
              Para el seguimiento ingresa al apartado de  <a href="/seguimiento" rel="noopener noreferrer"
              className="link">seguimiento</a>
            </p>
           
          </div>
        </div>
      </div>
      </Container>
      <FooterComponent/>
    </div >
  );
};

export default DetailPostQueja;
